import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-automatic-string-creation',
  templateUrl: './automatic-string-creation.component.html',
  styleUrls: ['./automatic-string-creation.component.css']
})
export class AutomaticStringCreationComponent {
  displayedColumns: string[] = ['s_no', 'string', 'type', 'operation'];
 dataSource : any = [{
  }];

  constructor(public dialog: MatDialog,) {

    }
  

}
